// extracted by mini-css-extract-plugin
export default {"listGroup":"CompetencyHexagonListV2_listGroup__JL5e2","listGroupIndent":"CompetencyHexagonListV2_listGroupIndent__DRAGc"};